import { Component, OnInit } from '@angular/core';
import { trigger, state, style, animate, transition } from '@angular/animations';
import { EnvironmentService } from 'src/app/trip-replay/services/img-source.service';
@Component({
  selector: 'app-side-view',
  templateUrl: './side-view.component.html',
  styleUrls: ['./side-view.component.scss'],
  animations: [
    trigger('expandedAnimation', [
      state('true', style({ transform: 'rotate(-180deg)', 'transform-origin': '50% 50%' })),
      state('false', style({ transform: 'rotate(0deg)', 'transform-origin': '50% 50%' })),
      transition('false <=> true', animate('0.5s ease-in-out'))
    ]),
    trigger('expandCollapse', [
      state('collapsed', style({
        height: '0px',
        opacity: 0,
        overflow: 'hidden'
      })),
      state('expanded', style({
        height: '*',
        opacity: 1,
        overflow: 'visible'
      })),
      transition('collapsed <=> expanded', [
        animate('500ms ease-in-out')
      ])
    ]),
    trigger('rotateArrow', [
      state('collapsed', style({
        transform: 'rotate(0deg)'
      })),
      state('expanded', style({
        transform: 'rotate(180deg)'
      })),
      transition('collapsed => expanded', [
        animate('0.3s')
      ]),
      transition('expanded => collapsed', [
        animate('0.3s')
      ])
    ])
  ]
})


export class SideViewComponent implements OnInit {
  imgSrc: string;
  constructor(private envService: EnvironmentService) { }
  
  expandedToggler:boolean=true

  ngOnInit(): void 
  {
    this.imgSrc = this.envService.getImgSrc();
  }

  expandedToggle()
  {
    this.expandedToggler=!this.expandedToggler
  }

}
